import { AxiosInstance } from 'axios';
import { PlansRepository } from '@/model/repository/manager/plans/PlansRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): PlansRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
